import { remark } from 'remark';
import html from 'remark-html';

export function convertMarkdownToHTMLString(markdown) {
  const result = remark().use(html).processSync(markdown);
  return result.toString();
}
